import React from "react";
import { BsGithub, BsLinkedin, BsInstagram, BsTwitter } from "react-icons/bs";
import { FaReact } from "react-icons/fa";
import { SiTailwindcss, SiNetlify } from "react-icons/si";
import { SOCIAL_LINKS } from "../../data";
import MainIntersectProvider from "../../MainIntersectProvider";

function Footer() {
	return (
		<section className='container px-5 xl:px-40 pt-10 mx-auto'>
			<div className='py-10'>
				<div
					style={{ height: "1px" }}
					className='w-full bg-gradient-to-r from-pink-500 to-yellow-500'
				/>
			</div>
			<div className='flex flex-row justify-center items-center'>
				<div className='flex flex-row space-x-5 pb-10'>
					<MainIntersectProvider animate='puff-in-center'>
						<a rel='noreferrer' href={SOCIAL_LINKS.github} target='_blank'>
							<BsGithub className='transform-gpu hover:scale-110 hover:text-yellow-500 transition-all text-2xl sm:text-3xl cursor-pointer' />
						</a>
					</MainIntersectProvider>
					<MainIntersectProvider animate='puff-in-center'>
						<a rel='noreferrer' href={SOCIAL_LINKS.linkedIn} target='_blank'>
							<BsLinkedin className='transform-gpu hover:scale-110 hover:text-yellow-500 transition-all text-2xl sm:text-3xl cursor-pointer' />
						</a>
					</MainIntersectProvider>
					<MainIntersectProvider animate='puff-in-center'>
						<a rel='noreferrer' href={SOCIAL_LINKS.instagram} target='_blank'>
							<BsInstagram className='transform-gpu hover:scale-110 hover:text-yellow-500 transition-all text-2xl sm:text-3xl cursor-pointer' />
						</a>
					</MainIntersectProvider>
					<MainIntersectProvider animate='puff-in-center'>
						<a rel='noreferrer' href={SOCIAL_LINKS.twitter} target='_blank'>
							<BsTwitter className='transform-gpu hover:scale-110 hover:text-yellow-500 transition-all text-2xl sm:text-3xl cursor-pointer' />
						</a>
					</MainIntersectProvider>
				</div>
			</div>
			<p className='pb-10 flex flex-wrap justify-center items-center font-mono font-normal text-xs md:text-sm text-gray-300'>
				{new Date().getFullYear()}, PRANAV MENE. BUILT WITH
				{
					<FaReact style={{ color: "#61DAFB" }} className='mx-2 animate-spin' />
				}{" "}
				AND {<SiTailwindcss style={{ color: "#38BDF8" }} className='mx-2' />}{" "}
				{"|"} DEPLOYED ON{" "}
				{<SiNetlify style={{ color: "#42A4BD" }} className='mx-2' />}
			</p>
		</section>
	);
}

export default Footer;
